class RunCarouselAnimation {
    constructor() {
        const LOTTIE = document.querySelector('.carousel .lottie');

        if (LOTTIE) {
            const GLOBAL_LOTTIE = CNOSF_APP.getModule('lottie');

            if (GLOBAL_LOTTIE.isLoaded) {
                Lottie.runAnimation(LOTTIE);
            } else {
                GLOBAL_LOTTIE.onload = () => {
                    Lottie.runAnimation(LOTTIE);
                };
            }
        }
    }
}